module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "int",
      "epub:type": "introduction",
      "role": "doc-introduction"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH1",
    attrs: {
      "id": "int"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "1",
      "id": "pg_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#ch_int",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("In every book I write, I try to express the")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("amount of strength that can be procured")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("from experiencing heartache.")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Never "), _c('i', [_vm._v("settle")]), _vm._v(" for any person or "), _c('i', [_vm._v("stay")]), _vm._v(" in")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("any situation that makes you feel")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("small or unimportant.")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('i', [_vm._v("I Needed a Viking")]), _vm._v(" was written to")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("ignite the warrior within you.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "V1"
  }, [_c('i', [_vm._v("Don’t be half the person")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("you really are")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("because you think")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("you need to downplay")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("your strength")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("to attract the right one.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f804d6e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 66
// module chunks = 0